import { render } from "./ClientDetailPage.vue?vue&type=template&id=6b1bf495&scoped=true"
import script from "./ClientDetailPage.vue?vue&type=script&lang=js"
export * from "./ClientDetailPage.vue?vue&type=script&lang=js"

import "./ClientDetailPage.vue?vue&type=style&index=0&id=6b1bf495&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1bf495"]])

export default __exports__